import React from 'react';
import {
    PrismicPreviewProvider,
    componentResolverFromMap,
} from 'gatsby-plugin-prismic-previews';
import GlobalStylesWrapper from './src/components/GlobalStylesWrapper/GlobalStylesWrapper';
import Root from './src/components/Root/Root';
import PageTemplate from './src/templates/page';
import linkResolver from './src/utils/linkResolver';


import '@fontsource/lato/400.css'
import '@fontsource/lato/700.css'
import '@fontsource/outfit/300.css'
import '@fontsource/outfit/400.css'
import '@fontsource/outfit/500.css'
import '@fontsource/outfit/600.css'
import '@fontsource/outfit/700.css'

const GSDEVTOOLS_ENABLED = false;

if (process.env.GATSBY_ACTIVE_ENV === 'development' && GSDEVTOOLS_ENABLED) {
    Promise.all([import('gsap'), import('gsap/dist/GSDevTools')]).then(
        ([{ gsap }, { GSDevTools }]) => {
            gsap.registerPlugin(GSDevTools);
            GSDevTools.create({
                visibility: 'auto',
            });
        }
    );
}
export const wrapPageElement = ({ element }) => (
    <GlobalStylesWrapper>{element}</GlobalStylesWrapper>
);
export const wrapRootElement = ({ element }) => (
    <PrismicPreviewProvider
        repositoryConfigs={[
            {
                repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
                linkResolver,
                componentResolver: componentResolverFromMap({
                    page: PageTemplate
                })
            },
        ]}
    >
        <Root>{element}</Root>
    </PrismicPreviewProvider>
);
